import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="loaderWrapper">
      <div className="loader" role="status"></div>
    </div>
  );
}

export default Loading;
